export function G_SIDEBAR__IMAGE_EDIT__view() {
  return <div className="size-full flex flex-col items-start justify-start gap-2 p-2"></div>;
}
